"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdDraftCreateOnlyPropertiesToJSON = exports.AdDraftCreateOnlyPropertiesFromJSONTyped = exports.AdDraftCreateOnlyPropertiesFromJSON = exports.instanceOfAdDraftCreateOnlyProperties = void 0;
/**
 * Check if a given object implements the AdDraftCreateOnlyProperties interface.
 */
function instanceOfAdDraftCreateOnlyProperties(value) {
    var isInstance = true;
    isInstance = isInstance && "adSetId" in value;
    return isInstance;
}
exports.instanceOfAdDraftCreateOnlyProperties = instanceOfAdDraftCreateOnlyProperties;
function AdDraftCreateOnlyPropertiesFromJSON(json) {
    return AdDraftCreateOnlyPropertiesFromJSONTyped(json, false);
}
exports.AdDraftCreateOnlyPropertiesFromJSON = AdDraftCreateOnlyPropertiesFromJSON;
function AdDraftCreateOnlyPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSetId': json['ad_set_id'],
    };
}
exports.AdDraftCreateOnlyPropertiesFromJSONTyped = AdDraftCreateOnlyPropertiesFromJSONTyped;
function AdDraftCreateOnlyPropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_set_id': value.adSetId,
    };
}
exports.AdDraftCreateOnlyPropertiesToJSON = AdDraftCreateOnlyPropertiesToJSON;
